<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <div v-if="$route.meta.keepAlive">
      <van-tabbar v-model="$store.state.tabBar" active-color="#48a26a" @change="tabbarChange"
        style="border-top:1px solid #f5f5f5">
        <van-tabbar-item name="index" icon="wap-home">主页</van-tabbar-item>
        <!-- <van-tabbar-item name="order"
                         icon="balance-list">申请</van-tabbar-item> -->
        <van-tabbar-item name="user" icon="manager-o">我的</van-tabbar-item>
      </van-tabbar>
    </div>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
// import { getWxUser } from '@/api/public';

export default {
  name: 'app',
  data() {
    return {};
  },
  methods: {
    tabbarChange(name) {
      this.$router.push('/' + name);
      this.$store.state.tabBar = name;
    },
  },
  created() {
    // let searchURL = window.location.search;
    // let code = '';
    // if (searchURL) {
    //   searchURL = searchURL.substring(1, searchURL.length);
    //   code = searchURL.split('&')[0].split('=')[1];
    // }
    // if (!code) {
    //   window.location.href =
    //     'https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww70fd72735961d8b1&redirect_uri=https://fcpg.shnsshrcb.com&response_type=code&scope=snsapi_privateinfo&state=STATE&agentid=1000039#wechat_redirect';
    // } else {
    //   getWxUser(code)
    //     .then((res) => {
    //       debugger;
    //       localStorage.setItem('auth', res.data);
    //       //window.location.href = 'https://fcpg.shnsshrcb.com/index';
    //       this.$router.push('/index');
    //     })
    //     .catch((e) => {
    //       console.log(e);
    //     });
    // }
  },
};
</script>
<style lang="less">
* {
  margin: 0;
  padding: 0;
}

html,
body {
  height: 100% !important;
}
#app {
  height: 100%;
}
.displayflex {
  display: flex;
}

.flexli {
  flex: 1;
}

.van-doc-demo-block__title {
  margin: 0;
  padding: 8px 8px 0px;
  color: rgba(69, 90, 100, 0.6);
  font-weight: normal;
  font-size: 10px;
  line-height: 14px;
}

.van-nav-bar {
  border-bottom: 1px solid #f5f5f5;
}
#app {
  height: 100%;
}

.van-button--info {
  background-color: #48a26a !important;
  border: 0.02667rem solid #48a26a !important;
}
</style>
